import React, { useEffect, useState } from 'react'
import Page from '../../component/Page';
import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getBranchList, getCatalogList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { REPORT_CONFIG } from './config'
import { getData } from '../../services/api';
const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReporttBalaneMaterials() {
    const [branchs, setBranchs] = useState([])
    const [Catalog, setCatalog] = useState([])
    const [materials, setMaterials] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [movementType, setMovementType] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [MaterialNo, setMaterialNo] = useState('')
    const [startDate, setStartDate] = useState(dayjs(new Date()).subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs(new Date()))
    const [reports, setReports] = useState([])
    const [sumValue, setSumValue] = useState()
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const { profile } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const getMaterials = async () => {
        const res = await getData('dbms/materials')
        const data = res.result
        setMaterials(data)
        console.log(data);
    }
    useEffect(() => {
        getBranchList(null, setBranchs)
        getCatalogList(null, setCatalog)
        LoadReport()
        getMaterials()
    }, [])


    async function getMaterialMovementReport(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getMaterialMovementReport.url}/${mode}`;


        let _params = '';
        let _sdate = '';
        let _edate = '';

        let _c = '';

        let _branchNo = '';
        let _MaterialNo = '';
        let _movementType = '';
        let _format = '';


        if (body.sdate) {
            _sdate = 'sdate=' + body.sdate;
        }
        if (body.edate) {
            _edate = '&edate=' + body.edate;
        }

        // if (body.c) {
        //     _c = '&c=' + (body.c !== '-' ? body.c : '');
        // }

        if (body.branchNo) {
            _branchNo = '&branchNo=' + (body.branchNo !== '-' ? body.branchNo : '');
        }
        if (body.MaterialNo) {
            _MaterialNo = '&materialCatalogNo=' + (body.MaterialNo !== '-' ? body.MaterialNo : '');
        }
        if (body.movementType) {
            _movementType = '&movementType=' + (body.movementType !== '-' ? body.movementType : '');
        }



        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _sdate + _edate + _c + _branchNo + _MaterialNo + _movementType + _format
        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data
            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานวัสดุการผลิตคงคลัง');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานวัสดุการผลิตคงคลัง');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
            edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
            branchNo: BranchNo || undefined,
            MaterialNo: MaterialNo || undefined,
            movementType: movementType || undefined,

            c: CatalogNo || undefined,

        };
        getMaterialMovementReport(body, 'data');

    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form >
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">

                                    <div class="col-12">

                                        <label class="labelInput">วันที่เริ่มต้น</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={startDate} onChange={e => setStartDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: startDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>

                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">วันที่สิ้นสุด</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={endDate} onChange={e => setEndDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: endDate } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>
                                    </div>
                                    {profile?.BranchNo?.BranchNo === '00' &&
                                        <div class="col-12">

                                            <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={BranchNo || '-'} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                        <MenuItem value='-'>-</MenuItem>
                                                        {branchs?.map((x) => (
                                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>}

                                    <div class="col-12">

                                        <label class="labelInput">รายการวัสดุ</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={MaterialNo || '-'} onChange={e => setMaterialNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {materials?.map((x) => (
                                                        <MenuItem value={x?.ItemNo}>{x?.ItemName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">ประเภทการทำรายการ</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={movementType || '-'} onChange={e => setMovementType(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {['รับ', 'จ่าย', 'โอน', 'ยืม', 'แจ้งซ่อม', 'คืน', 'คืน-จ่าย', 'คืน-ยืม', 'คืน-ซ่อม', 'ซ่อม', 'ตัดบัญชี']?.map((x) => (
                                                        <MenuItem value={x}>{x}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>

                                    <div class="col-12">
                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานวัสดุการผลิตคงคลัง
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    MaterialNo: MaterialNo || undefined,
                                                    movementType: movementType || undefined,
                                                    c: CatalogNo || undefined,

                                                };
                                                // setFormat('')
                                                getMaterialMovementReport(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    sdate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
                                                    edate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    MaterialNo: MaterialNo || undefined,
                                                    movementType: movementType || undefined,
                                                    c: CatalogNo || undefined,

                                                };
                                                // setFormat('pdf')
                                                getMaterialMovementReport(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div>

                                </div>
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{ height: 'auto' }}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col" >วันที่ทำรายการ</th>
                                                        <th scope="col" >เลขที่เอกสาร</th>
                                                        <th scope="col" >ประเภทการทำรายการ</th>
                                                        <th scope="col" >ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col" >รายการ</th>
                                                        <th scope="col" >ประเภทเงินที่จัดซื้อ/จัดทำ</th>
                                                        <th scope="col" >ปีงบประมาณที่จัดซื้อ/จัดทำ</th>
                                                        <th scope="col" >เลขครุภัณฑ์</th>
                                                        <th scope="col" >หน่วย</th>
                                                        <th scope="col" >ราคา/หน่วย (บาท)</th>
                                                        <th scope="col" >ปริมาณรับ</th>
                                                        <th scope="col" >ปริมาณจ่าย</th>
                                                        <th scope="col" >ปริมาณคืน</th>
                                                        <th scope="col" >อายุการใช้งาน</th>
                                                        <th scope="col" >สถานะ</th>
                                                        <th scope="col" >ขนาด</th>
                                                        <th scope="col" >หมายเหตุ</th>

                                                    </tr>


                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (

                                                        <tr class="cp">
                                                            <td class="text-center">{dayjs(report?.DocumentDate).format('DD/MM/YYYY')}</td>
                                                            <td class="text-center">{report?.DocumentNo || '-'}</td>
                                                            <td class="text-center">{report?.DocumentType}</td>
                                                            <td class="text-center">{report?.BranchName}</td>
                                                            <td class="text-center">{report?.ItemName}</td>
                                                            <td class="text-center">{report?.BudgetType}</td>
                                                            <td class="text-center">{report?.BudgetYear}</td>
                                                            <td class="text-center">{report?.Lot || '-'}</td>
                                                            <td class="text-center">{report?.UnitName}</td>
                                                            <td class="text-center">{report?.CostPrice?.toLocaleString()}</td>
                                                            <td class="text-center">{report?.ReceiveQty?.toLocaleString()}</td>
                                                            <td class="text-center">{report?.ExpenseQty?.toLocaleString()}</td>
                                                            <td class="text-center">{report?.ReturnQty?.toLocaleString()}</td>
                                                            <td class="text-center">{report?.Age}</td>
                                                            <td class="text-center">{report?.Status}</td>
                                                            <td class="text-center">{report?.Size || '-'}</td>
                                                            <td class="text-center">{report?.Remark || '-'}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {/* <thead class="sticky-tfooter">
                                            <tr>
                                                <th scope="col" colspan="9">รวม</th>
                                                <th class="text-center">{sumValue?.Reason.Plant.toLocaleString()}</th>
                                                <th class="text-center">{sumValue?.Reason.Sale.toLocaleString()}</th>
                                                <th class="text-center">{sumValue?.Reason.Other.toLocaleString()}</th>
                                            </tr>
                                        </thead> */}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>

                    </form>
                </div>
            </Page>
        </div>
    )
}
